import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import logo from '../assets/branding/logo-hero.png';

const navigationItems = [
  { label: "Services", href: "#services" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Showcase", href: "#showcase" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" }
];

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (item) => {
    if (item.isRoute) {
      // Handle route navigation
      setIsMobileMenuOpen(false);
    } else {
      // Handle scroll-to-section
      const element = document.querySelector(item.href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMobileMenuOpen(false);
      }
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/95 backdrop-blur-sm border-b border-gray-800' : 'bg-transparent'
      }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">


          <div className="flex-shrink-0 cursor-pointer">
            <img
              src={logo}
              alt="HARA-XY Logo"
              className="h-8 sm:h-10 w-auto"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-6 lg:ml-10 flex items-baseline space-x-4 lg:space-x-8">
              {navigationItems.map((item, index) => (
                item.isRoute ? (
                  <Link
                    key={index}
                    to={item.href}
                    className="text-gray-300 hover:text-white px-2 lg:px-3 py-2 text-sm font-medium transition-colors duration-300 hover:underline underline-offset-4"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <button
                    key={index}
                    onClick={() => handleNavigation(item)}
                    className="text-gray-300 hover:text-white px-2 lg:px-3 py-2 text-sm font-medium transition-colors duration-300 hover:underline underline-offset-4"
                  >
                    {item.label}
                  </button>
                )
              ))}
              <button className="bg-silver text-black px-4 lg:px-6 py-2 rounded-full font-medium text-sm hover:bg-white transition-all duration-300 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-silver/50">
                Get Started
              </button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-300 hover:text-white p-2 focus:outline-none focus:ring-2 focus:ring-white/50 rounded-lg"
              aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={isMobileMenuOpen}
              aria-controls="mobile-menu"
            >
              {isMobileMenuOpen ? <X size={20} className="sm:hidden" /> : <Menu size={20} className="sm:hidden" />}
              {isMobileMenuOpen ? <X size={24} className="hidden sm:block" /> : <Menu size={24} className="hidden sm:block" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div id="mobile-menu" className="md:hidden bg-black/95 backdrop-blur-sm border-b border-gray-800" role="navigation" aria-label="Mobile navigation">
          <div className="px-4 pt-4 pb-6 space-y-2">
            {navigationItems.map((item, index) => (
              item.isRoute ? (
                <Link
                  key={index}
                  to={item.href}
                  className="text-gray-300 hover:text-white block px-3 py-3 text-base font-medium w-full text-left transition-colors duration-300"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ) : (
                <button
                  key={index}
                  onClick={() => handleNavigation(item)}
                  className="text-gray-300 hover:text-white block px-3 py-3 text-base font-medium w-full text-left transition-colors duration-300"
                >
                  {item.label}
                </button>
              )
            ))}
            <button className="bg-silver text-black px-6 py-3 rounded-full font-medium text-sm hover:bg-white transition-all duration-300 mt-6 mx-3 w-[calc(100%-1.5rem)]">
              Get Started
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;